import * as React from "react";
import PropTypes from "prop-types";
const SvgNavigationInformationNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M8.625 12V7h-1.25v5zM8.625 4v1.25h-1.25V4z" />
        <path d="M0 8a8 8 0 1116 0A8 8 0 010 8zm8-6.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5z" />
      </g>
    </svg>
  )
);
SvgNavigationInformationNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgNavigationInformationNormalXsmall;
